import { SimpleAccordion } from '@dreamstack/feature-components/src/Accordion/SimpleAccordion'
import { BlockAccordion } from '@dreamstack/payload/src/payload-types'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { useRef, useState } from 'react'
import { ContentfulBlock } from '../contentful/ContentfulBlock'
import { AccordionEntry } from './AccordionEntry'

export const Accordion: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockAccordion
  }>
> = ({ block }) => {
  const itemsRef = useRef<Array<HTMLDivElement | null>>([])
  const [, setOpenNodeIndex] = useState(-1)

  const processAccordionEntryClick = (index: number, isOpen: boolean) => {
    if (isOpen) {
      setOpenNodeIndex(-1)
    } else {
      setOpenNodeIndex((oldIndex) => {
        if (oldIndex !== index) {
          const elem = itemsRef.current[oldIndex]
          if (elem) {
            const child = elem.querySelector('dt')?.firstChild as HTMLElement
            child?.click()
          }
        }
        return index
      })
    }
  }

  const blockChildren = block.accordionEntry ?? []

  return (
    <>
      <SimpleAccordion widgetType={block?.widgetType ?? undefined}>
        {map(blockChildren, (child, index) => {
          return (
            <div
              key={child.id}
              ref={(el) => {
                itemsRef.current[index] = el
              }}
            >
              <AccordionEntry
                block={child}
                customProps={{
                  smallSize: block.smallSize ?? false,
                  widgetType: block.widgetType ?? 'DefaultAccordion',
                  processAccordionEntryClick: block.isControlled
                    ? processAccordionEntryClick
                    : undefined,
                  index,
                  useAqua: block.aquaColor ?? false,
                }}
              >
                <ContentfulBlock block={child} />
              </AccordionEntry>
            </div>
          )
        })}
      </SimpleAccordion>
    </>
  )
}
